import { Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import {
    TokenRequestDto,
    UserCredentialControllerService,
} from '@api-swagger-client/index';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs';
import { RuntimeConfigService } from './runtime-config.service';

@Injectable({
    providedIn: 'root',
})
export class MessagingService {
    currentMessage = new BehaviorSubject<any>(null);
    private fcmToken: string | null = null;
    private audio = new Audio('assets/notification-sound.mp3');
    private audioEnabled = false;

    constructor(
        private messaging: Messaging,
        private userCredentialControllerService: UserCredentialControllerService,
        private runtimeConfigService: RuntimeConfigService
    ) {}

    // Solicitar permiso de notificaciones Y habilitar audio en el mismo flujo
    async requestPermission(): Promise<string | null> {
        try {
            /* const permission = await Notification.requestPermission();

            if (permission !== 'granted') {
                return null;
            }

            await this.enableAudio(); */

            const token = await getToken(this.messaging, {
                vapidKey: this.runtimeConfigService.firebase['vapidKey'],
            });

            if (token) {
                this.fcmToken = token;
                this.sendTokenToServer(token);
                return token;
            } else {
                return null;
            }
        } catch (err) {
            return null;
        }
    }

    private async enableAudio(): Promise<void> {
        try {
            this.audio.load();
            this.audioEnabled = true;
        } catch (error) {
            this.audioEnabled = false;
        }
    }

    listen() {
        onMessage(this.messaging, (payload) => {
            this.currentMessage.next(payload);
            this.playNotificationSound();
        });
    }

    private playNotificationSound() {
        if (!this.audioEnabled) return;

        const audio = new Audio('assets/notification-sound.mp3');
        audio.volume = 0.3;
        audio.play().catch(() => {});
    }

    private showBrowserNotification(payload: any) {
        if ('Notification' in window && Notification.permission === 'granted') {
            const title = payload?.notification?.title || 'Nueva notificación';
            const options = {
                body: payload?.notification?.body || '',
                icon: 'assets/logos/logo.png',
                badge: 'assets/logos/logo.png',
                vibrate: [200, 100, 200],
                silent: false,
            };

            new Notification(title, options);
        }
    }

    getToken(): string | null {
        return this.fcmToken;
    }
    private sendTokenToServer(token: string): void {
        const tokenRequest: TokenRequestDto = {
            token,
            tokenType: 'web',
        };

        this.userCredentialControllerService
            .userCredentialControllerAddFCMToken(tokenRequest)
            .subscribe({
                next: (response) => {
                    if (response.success) {
                       
                        localStorage.setItem('fcm_web_token', token);
                    } else {

                    }
                },
                error: (error) => {
                    localStorage.setItem('fcm_web_token_pending', token);
                },
            });
    }
}
